import axios from "@/lib/axios";

export type AppealReviewRequestParams = {
  companyId: string;
  applicationQuizId: string;
  details: Array<{
    questionId: string;
    questionNumber: string;
    comment: string;
  }>;
};

export type AppealReviewResponse = void;

export const appealReview = (params: AppealReviewRequestParams) =>
  axios
    .post<AppealReviewResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.applicationQuizId}/appeal-review`,
      {
        details: params.details,
      },
    )
    .then((res) => res.data);
